import { createFileRoute, redirect } from "@tanstack/react-router";
import { getPinForRaid } from "@/raids/pinStore.ts";
import { RaidEditDetails } from "@/raids/RaidEditDetails.tsx";

export const Route = createFileRoute("/raids_/$raidId/edit")({
  beforeLoad: ({ params }) => {
    const id = Number(params.raidId);
    if (!Number.isFinite(id) || id <= 0 || !getPinForRaid(id)) {
      throw redirect({
        to: "/raids/$raidId",
        params: { raidId: params.raidId },
      });
    }
  },
  component: () => <RaidEditDetails />,
});
